import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { PlautoService } from '@amfam/policy/data-access';
import { PolicyAnalytics } from '@amfam/policy/models';
import { VehicleFeatures, VehicleQuoteService } from '@amfam/policy/shared';
import { AnalyticsFacade } from '@amfam/shared/analytics';
import { PaymentScheduleItem, QuoteSummaryModel } from '@amfam/shared/models';
import { Agent, agentQuery } from '@amfam/shared/utility/agent';
import { BrandSelectors } from '@amfam/shared/utility/brand';
import { ImpersonateRolesService } from '@amfam/shared/utility/impersonation';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { CopyService, UtilService } from '@amfam/shared/utility/shared-services';
import { DsModalService, LoadingSpinnerService } from '@amfam/ui-kit';

import { addVehicleFeatureQuery } from '../+state/add-vehicle-feature.selectors';
import { AddVehicleFeatureService } from '../services/add-vehicle-feature.service';

@Component({
  selector: 'ds-vehicle-future-payment-schedule',
  templateUrl: './vehicle-future-payment-schedule.component.html',
  styleUrls: ['./vehicle-future-payment-schedule.component.scss'],
  standalone: false
})
export class VehicleFuturePaymentScheduleComponent implements OnInit, AfterViewInit {
  @Output() cancelEvent = new EventEmitter<boolean>();
  @Output() notifyAgentEvent = new EventEmitter<unknown>();

  futurePayments$: Observable<QuoteSummaryModel[]>;

  public authorized$ = this.roleService.isAuthorized('addvehicle_sendtoagent');
  isPartner$ = this.store.select(BrandSelectors.selectIsPartner);
  public agentSelectionModalId = this.modalService.createModalId();
  public agents$ = this.store.select(agentQuery.getRealAgents);
  vehicleFeatures = VehicleFeatures;

  constructor(
    protected store: Store,
    protected formBuilder: UntypedFormBuilder,
    protected spinnerService: LoadingSpinnerService,
    protected copyService: CopyService,
    protected autoPolicyService: PlautoService,
    protected modalService: DsModalService,
    protected addVehicleService: AddVehicleFeatureService,
    protected utilService: UtilService,
    protected roleService: ImpersonateRolesService,
    private vehicleQuoteService: VehicleQuoteService,
    private analyticsFacade: AnalyticsFacade
  ) {}

  ngOnInit(): void {
    this.futurePayments$ = this.store.select(addVehicleFeatureQuery.selectFuturePayments).pipe(
      filter(payments => !!payments),
      map((payments: PaymentScheduleItem[]) => this.vehicleQuoteService.mapPayments(payments))
    );
  }

  ngAfterViewInit() {
    this.analyticsFacade.trackPage(PolicyAnalytics.pagePolicyAddVehicleFuturePaymentSchedule);
  }

  nextStep() {
    this.store.dispatch(
      fromRouterActions.Go({
        path: [`policies/add-vehicle/vehicle-quote-summary`]
      })
    );
  }

  goBackOneStep() {
    this.store.dispatch(fromRouterActions.Back());
  }

  agentConfirmationFromModal(agent: Agent) {
    this.notifyAgentEvent.emit({ agent });
  }

  cancelEventFromAgentSelectionModal() {}
}
